import { createFileRoute } from "@tanstack/react-router";
import { clientsQueryOptions } from "creso-core/hooks";
import { lazy } from "react";
import { array, number, object, string, z } from "zod";
import { zodValidator } from "@tanstack/zod-adapter";
import { ClientStatusSchema } from "creso-core/zod";

const Component = lazy(() => import("@crm/pages/clients"));

export const Route = createFileRoute("/(auth)/_headed/clients/_layout/")({
  component: Component,
  validateSearch: zodValidator(
    object({
      page: number().optional(),
      pageSize: number().optional(),
      search: string().optional(),
      status: array(ClientStatusSchema).optional(),
      tax_status: array(string()).optional(),
      manage_clients: z.coerce.boolean().optional(),
      assign_to_employee_id: z.coerce.number().optional(),
      filter_employee_id: z.coerce.number().optional(),
    })
  ),
  loaderDeps: ({ search }) => ({
    page: search.page,
    pageSize: search.pageSize,
    status: search.status,
    search: search.search,
  }),
  loader: async ({ context, deps }) => {
    const { queryClient } = context;
    const { page, pageSize, status, search } = deps;

    const clients = await queryClient
      .ensureQueryData(
        clientsQueryOptions({ page, pageSize, filters: { status }, search })
      )
      .catch(() => {
        return { results: [], count: 0, next: "", previous: "" };
      });

    return { clients };
  },
});
